define('Product.Model.ImagesSorting', [
    'Product.Model',
    'Item.Model',

    'underscore'
],
function ProductModelImagesSorting(
    ProductModel,
    ItemModel,

    _
) {
    'use strict';

    function getImages(images, item) {
        var sortedImages = images;
        var itemImagesDetail = item.get('itemimages_detail');
        var mediaImages = itemImagesDetail ? itemImagesDetail.media : null;
        var mediaImagesUrls = mediaImages ? mediaImages.urls : [];
        var heroImage;

        if (sortedImages && sortedImages.length && mediaImagesUrls) {
            heroImage = _(mediaImagesUrls).find(function find(mediaImage) {
                return mediaImage && mediaImage.url && mediaImage.url.indexOf('media-1') !== -1;
            });

            if (heroImage && _(sortedImages).contains(heroImage)) {
                sortedImages = _(sortedImages).without(heroImage);
                sortedImages = [heroImage].concat(sortedImages);
            }
        }

        return sortedImages;
    }

    function getImagesForItem(fn) {
        var images = fn.apply(this, _.toArray(arguments).slice(1));

        return getImages(images, this);
    }

    function getImagesForProduct(fn) {
        var images = fn.apply(this, _.toArray(arguments).slice(1));

        return getImages(images, this.get('item'));
    }

    ProductModel.prototype.getImages = _(ProductModel.prototype.getImages).wrap(getImagesForProduct);
    ItemModel.prototype.getImages = _(ItemModel.prototype.getImages).wrap(getImagesForItem);
});

